<template>
    <div class="v-context"
         v-show="show && actions && actions.length"
         :style="style"
         tabindex="-1"
         v-on-clickaway="close"
         @click="onClick"
         @contextmenu.capture.prevent>
        <ul class="v-context-list">
            <li class="v-context-list-item"
                :class="{disabled: action.disabled}"
                v-if="!action.hidden"
                v-for="action in actions"
                @click="click(action.name, data)">
                <span class="v-context-icon">
                    <i class="fas" :class="'fa-' + (action.icon || 'arrow-right')"></i>
                    <span v-if="action['additionalIcon']" class="v-context-additional-icon">
                    <i class="fas" :class="'fa-' + (action.additionalIcon || 'arrow-right')"></i>
                </span>
                </span>

                <span class="v-context-text">{{action.title}}</span>
            </li>
        </ul>
        <slot :data="data"></slot>
    </div>
</template>

<script>
    import {mixin as clickaway} from 'vue-clickaway';

    /**
     * Контекстное меню вызываемое
     * кликом правой кнопки мыши
     * Может быть созданно двумя путями
     */
    export default {
        mixins: [clickaway],
        props: {
            actions: null,
            closeOnClick: {
                type: Boolean,
                default: true
            },
            closeOnScroll: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            /**
             * Generate the CSS styles for positioning the context menu.
             * @returns {object|null}
             */
            style() {
                return this.show
                    ? {top: `${this.top}px`, left: `${this.left}px`}
                    : null;
            }
        },
        data() {
            return {
                top: null,
                left: null,
                show: false,
                data: null
            };
        },
        mounted() {
            if (this.closeOnScroll) {
                this.addScrollEventListener();
            }
        },
        beforeDestroy() {
            if (this.closeOnScroll) {
                this.removeScrollEventListener();
            }
        },
        methods: {
            /**
             * Add scroll event listener to close context menu.
             */
            addScrollEventListener() {
                window.addEventListener('scroll', this.close);
            },
            /**
             * Закрытие контекстного меню
             * @param {boolean|Event} emit - Сообщение о закрытии?
             */
            close(emit = true) {
                if (!this.show) {
                    return;
                }
                this.top = null;
                this.left = null;
                this.data = null;
                this.show = false;
                if (emit) {
                    this.$emit('close');
                }
            },
            /**
             * Close the menu if `closeOnClick` is set to true.
             */
            onClick() {
                if (this.closeOnClick) {
                    this.close(false);
                }
            },
            /**
             * Open the context menu.
             *
             * @param {MouseEvent} event
             * @param {array|object|string} data User provided data for the menu
             */
            open(event, data) {
                this.data = data;
                this.show = true;
                this.$nextTick(() => {
                    this.positionMenu(event.clientY, event.clientX);
                    this.$el.focus();
                    this.$emit('open', event, this.data, this.top, this.left);
                });
            },
            /**
             * Set the context menu top and left positions.
             *
             * @param {number} top
             * @param {number} left
             */
            positionMenu(top, left) {
                const largestHeight = window.innerHeight - this.$el.offsetHeight - 25;
                const largestWidth = window.innerWidth - this.$el.offsetWidth - 25;
                if (top > largestHeight) {
                    top = largestHeight;
                }
                if (left > largestWidth) {
                    left = largestWidth;
                }
                this.top = top;
                this.left = left;
            },
            /**
             * Remove the scroll event listener to close the context menu.
             */
            removeScrollEventListener() {
                window.removeEventListener('scroll', this.close);
            },

            click(actionName, data) {
                this.$emit('action-handle', {name: actionName, data: data})
            }
        },
        watch: {
            /**
             * Add or remove the scroll event listener when the prop value changes.
             *
             * @param {boolean} value
             * @param {boolean} oldValue
             */
            closeOnScroll(value, oldValue) {
                if (value === oldValue) {
                    return;
                }
                if (value) {
                    this.addScrollEventListener();
                } else {
                    this.removeScrollEventListener();
                }
            }
        }
    };
</script>